import { gql } from '@apollo/client';

const SET_NOTIFICATION_AS_READ = gql`
  mutation SetNotificationAsRead($notificationId: Int!) {
    setNotificationAsRead(notificationId: $notificationId)
  }
`;

export default SET_NOTIFICATION_AS_READ;
